export type WebLink = {
    title: string,
    type: 'title'
} | {
    title: string,
    type: 'link' | 'card',
    image: string,
    url: string,
    coupon?: string
    percent?: number
    price?: number
    youtube?: string
} | {
    title?: string,
    type: "banner",
    coupon?: string,
    percent?: number,
    image: string,
    url: string
}
    | {
        title: string,
        type: 'expand',
        image: string,
        data: WebLink[]
    }

const tastiere: WebLink[] = [
    {
        title: 'le tastiere dei video',
        type: 'title',
    },
    {
        title: 'Nuphy GEM80',
        url: 'https://bit.ly/3SgIHuH',
        type: 'link',
        coupon: 'NICOLA',
        percent: 10,
        image: 'img/gem80.png',
    },
    {
        title: 'Nuphy Halo75',
        url: 'http://bit.ly/3gcmorf',
        type: 'link',
        coupon: 'NICOLA',
        percent: 10,
        image: 'img/nuphyhalo75.png',
        youtube: 'https://yt.openinapp.co/os5yb'
    },
    {
        title: 'Nuphy Air96',
        url: 'https://bit.ly/3Gzm3sF',
        type: 'link',
        coupon: 'NICOLA',
        percent: 10,
        image: 'img/nuphyair96.png',
        youtube: 'https://yt.openinapp.co/r0wgy'
    },
    {
        title: 'Wooting 60HE',
        url: 'https://bit.ly/3UqB2dR',
        type: 'link',
        image: 'img/woting.png',
        youtube: 'https://yt.openinapp.co/cwwu6'
    },
    {
        title: 'Ajazz AC067',
        coupon: "NICOLA10",
        percent: 10,
        url: 'https://bit.ly/3HWRwpz',
        type: 'link',
        image: 'img/ac067.png',
        youtube: 'https://yt.openinapp.co/2uzaz'
    },
    {
        title: 'HHKB Type-S',
        url: 'https://amzn.to/3FzbmoQ',
        type: 'link',
        image: 'img/hhkb.png',
        youtube: 'https://yt.openinapp.co/xy6nl'
    },

    {
        title: 'AKKO SPR67',
        url: 'https://akkogear.eu/products/spr-67-diy-kit?ref=saglia',
        type: 'link',
        coupon: 'Nicola Sagliano',
        percent: 10,
        image: 'img/spr67.png',
        youtube: 'https://yt.openinapp.co/sxhkf'
    },
    {
        title: 'Monsgeek M1',
        url: 'https://akkogear.eu/products/monsgeek-m1-diy-kit?ref=saglia',
        type: 'link',
        coupon: 'Nicola Sagliano',
        percent: 10,
        image: 'img/m1.png',
        youtube: 'https://yt.openinapp.co/wlk7v'
    },
    {
        title: 'MXRSKEY CK820',
        coupon: "NICOLA10",
        percent: 10,
        url: 'http://bit.ly/3TIZDIV',
        type: 'link',
        image: 'img/MXRSKEYCK820.png',
        youtube: 'https://yt.openinapp.co/7xp1b'
    }
]

const switches: WebLink[] = [
    {
        title: 'gli switch dei video',
        type: 'title',
    },
    {
        title: 'Durock Black Lotus',
        url: 'https://khor.store/products/durock-black-lotus10pz?sca_ref=3371947.hdVwYhJ4du',
        type: 'link',
        coupon: "SAGLIA5",
        percent: 5,
        image: 'img/durocklotus.png',
        youtube: 'https://yt.openinapp.co/smpiq'
    },
    {
        title: 'JWICK Black V2',
        url: 'https://khor.store/products/jwk-jwick-black-v2-10pz?sca_ref=3371947.hdVwYhJ4du',
        type: 'link',
        image: 'img/jwickblackv2.png',
        youtube: 'https://yt.openinapp.co/a18z0'
    },
    {
        title: 'KTT Rose',
        url: 'https://khor.store/products/ktt-rose-10pz?sca_ref=3371947.hdVwYhJ4du',
        type: 'link',
        image: 'img/kttrose.png',
        youtube: 'https://yt.openinapp.co/cpe3v'
    },
    {
        title: 'KTT Strawberry',
        url: 'https://khor.store/products/ktt-strawberry-10pz?sca_ref=3371947.hdVwYhJ4du',
        type: 'link',
        image: 'img/kttstrawbarry.png'
    },
    {
        title: 'KTT Kang White',
        url: 'https://khor.store/products/ktt-kang-white-10pz?sca_ref=3371947.hdVwYhJ4du',
        type: 'link',
        image: 'img/kangwhite.png'
    },
    {
        title: 'Akko haze pink',
        url: 'https://akkogear.eu/products/akko-haze-pink-silent-switch-45pcs?ref=saglia',
        type: 'link',
        image: 'img/hazepink.png',
        youtube: 'https://yt.openinapp.co/axhdf'
    },
    {
        title: 'Durock Mamba',
        url: 'https://bit.ly/3OPjjKz',
        type: 'link',
        image: 'img/durockmamba.png',
        youtube: 'https://yt.openinapp.co/o5u37'
    },
    {
        title: 'Akko cs snow gray',
        url: 'https://akkogear.eu/products/akko-cs-snow-blue-gray-switch-45pcs?ref=saglia',
        type: 'link',
        image: 'img/akkosnowblue.webp',
        youtube: 'https://yt.openinapp.co/aaigh'
    },
    {
        title: 'Red Jacket V2',
        url: 'https://bit.ly/3Rf8jqM',
        type: 'link',
        image: 'img/redj.png',
        youtube: 'https://yt.openinapp.co/u0ofl'
    }


]

const tappetini: WebLink[] = [
    {
        title: 'Alcuni tappetini che utlizzo',
        type: 'title',
    },
    {
        title: 'Base in feltro',
        url: 'https://amzn.to/3Rj1EMp',
        type: 'link',
        image: 'img/feltro.png'
    },
    {
        title: 'Great Wave',
        url: 'https://s.click.aliexpress.com/e/_DCsA5hh',
        type: 'link',
        image: 'img/greatwave.png'
    },

]

const cavi: WebLink[] = [
    {
        title: 'i cavi dei video',
        type: 'title',
    },
    {
        title: 'Gunmetal GX-16',
        url: 'https://khor.store/products/gx-12?sca_ref=3371947.hdVwYhJ4du',
        coupon: "SAGLIA5",
        percent: 5,
        type: 'link',
        image: 'img/gunmetal.png'
    },
    {
        title: 'Andromeda GX-12',
        url: 'https://khor.store/products/gx-12-andromeda?sca_ref=3371947.hdVwYhJ4du',
        coupon: "SAGLIA5",
        percent: 5,
        type: 'link',
        image: 'img/andromeda.png'
    },
    {
        title: 'Los Angeles GX-12',
        url: 'https://bit.ly/3Y2rlDe',
        coupon: "SAGLIA5",
        percent: 5,
        type: 'link',
        image: 'img/la.png'
    },
    {
        title: 'Interstellar White GX-16',
        url: 'https://khor.store/products/gx-16-interstellae?sca_ref=3371947.hdVwYhJ4du',
        coupon: "SAGLIA5",
        percent: 5,
        type: 'link',
        image: 'img/interstellar.png'
    },
    {
        title: 'Espresso GX-12',
        url: 'https://khor.store/products/gx-12-espresso?sca_ref=3371947.hdVwYhJ4du',
        coupon: "SAGLIA5",
        percent: 5,
        type: 'link',
        image: 'img/espresso.png'
    },
    {
        title: 'Old School GX-12',
        url: 'https://khor.store/products/gx-12-old-school?sca_ref=3371947.hdVwYhJ4du',
        coupon: "SAGLIA5",
        percent: 5,
        type: 'link',
        image: 'img/oldschool.png'
    },
    {
        title: 'Khor store',
        url: 'https://khor.store?sca_ref=3371947.hdVwYhJ4du',
        coupon: "SAGLIA5",
        percent: 5,
        type: 'link',
        image: 'img/khor.avif'
    },
]

const accessoriTastiere: WebLink[] = [
    {
        title: 'quello che ti può servire',
        type: 'title',
    },
    {
        title: 'Krytox 205g0',
        url: 'https://bit.ly/3kKoWyA',
        type: 'link',
        image: 'img/205.png'
    },
    {
        title: 'Krytox GPL 105',
        url: 'https://bit.ly/3WJFMeh',
        type: 'link',
        image: 'img/105.png'
    },
    {
        title: 'XHT-BDZ',
        url: 'https://bit.ly/3kO4fSx',
        type: 'link',
        image: 'img/bdz.png'
    },
    {
        title: 'Nastro adesivo Tape Mod',
        url: 'https://amzn.to/3wB6FGN',
        type: 'link',
        image: 'img/nastro.png'
    },
    {
        title: 'Tronchesino',
        url: 'https://amzn.to/3Dpf3Ng',
        type: 'link',
        image: 'img/tronchesino.png'
    },
    {
        title: 'Set pinzette',
        url: 'https://amzn.to/3wYi97v',
        type: 'link',
        image: 'img/pinzette.png'
    }
    // {
    //     title: 'Switch opener',
    //     url: 'https://bit.ly/3Hax3Mo',
    //     type: 'link',
    //     image: 'img/accessori.png'
    // },
    // {
    //     title: 'Switch Puller',
    //     url: 'https://bit.ly/3Hax3Mo',
    //     type: 'link',
    //     image: 'img/accessori.png'
    // },
]

const camere: WebLink[] = [
    {
        title: 'Le camere che utilizzo',
        type: 'title',
    },
    {
        title: 'Lumix S5',
        url: 'https://amzn.to/3XP3sz9',
        type: 'link',
        image: 'img/s5.png'
    },
    {
        title: 'Lumix GH5S',
        url: 'https://amzn.to/3wHCmhI',
        type: 'link',
        image: 'img/GH5S.png'
    },
    {
        title: 'Sigma 16 mm F1.4 - Micro 4/3',
        url: 'https://amzn.to/3wFhFmr',
        type: 'link',
        image: 'img/sigma16.png'
    },
    {
        title: 'Panasonic S35mm F1.8 - L Mount',
        url: 'https://amzn.to/3wDmcFV',
        type: 'link',
        image: 'img/pana35.png'
    },
    {
        title: 'Sigma 28-70mm F2.8 - L Mount',
        url: 'https://amzn.to/3XFhaoh',
        type: 'link',
        image: 'img/sigma2870.png'
    },
]

const accessori: WebLink[] = [
    {
        title: 'Alcuni accessori fotografici',
        type: 'title',
    },
    {
        title: 'Manfrotto testa fluida 502',
        url: 'https://amzn.to/3JqqEzt',
        type: 'link',
        image: 'img/fluida.png'
    },
    {
        title: 'Manfrotto Treppiede',
        url: 'https://amzn.to/3DlRNQc',
        type: 'link',
        image: 'img/treppiede.png'
    },
    {
        title: 'Lexar Scheda SD 256GB UHS-II',
        url: 'https://amzn.to/3WMdpMn',
        type: 'link',
        image: 'img/scheda.png'
    },
    {
        title: 'Peso per treppiedi 4.4 kg',
        url: 'https://amzn.to/40h2mOy',
        type: 'link',
        image: 'img/peso.png'
    },
    {
        title: 'Filtro ND Variabile ø77mm',
        url: 'https://amzn.to/3JqNt6e',
        type: 'link',
        image: 'img/filtro.png'
    },
    {
        title: 'Gimbal WEEBILL-S',
        url: 'https://amzn.to/3Y00sQs',
        type: 'link',
        image: 'img/gimbal.png'
    },
    {
        title: 'JOBY GorillaPod 3K',
        url: 'https://amzn.to/3WHQLVy',
        type: 'link',
        image: 'img/gorilla.png'
    },
    {
        title: 'Lowepro Truckee BP 250',
        url: 'https://amzn.to/3wGGaQ2',
        type: 'link',
        image: 'img/zaino.png'
    },
    {
        title: 'Dolly Andoer L4 PRO',
        url: 'https://amzn.to/3Y8QQms',
        type: 'link',
        image: 'img/dolly.png'
    },
]

const audio: WebLink[] = [
    {
        title: 'I miei accessori audio',
        type: 'title',
    },
    {
        title: 'DJI Mic',
        url: 'https://amzn.to/3jaUaP9',
        type: 'link',
        image: 'img/djimic.png'
    },
    {
        title: 'Lavalier Sony ECM-LV1',
        url: 'https://amzn.to/3XLy4l3',
        type: 'link',
        image: 'img/lavsony.png'
    },
    {
        title: 'RODE NTG4',
        url: 'https://amzn.to/3Y60aHt',
        type: 'link',
        image: 'img/ntg4.png'
    },
    {
        title: 'Pannelli Fonoassorbenti',
        url: 'https://amzn.to/3jfzy8d',
        type: 'link',
        image: 'img/fono.png'
    },


]

const luci: WebLink[] = [
    {
        title: 'Le luci dei miei video',
        type: 'title',
    },
    {
        title: 'Zhiyun Molus X100',
        url: 'https://amzn.to/44MSiOZ',
        type: 'link',
        image: 'img/molusx100.png'
    },
    {
        title: 'Godox SL100D 100W',
        url: 'https://amzn.to/3Jli4SB',
        type: 'link',
        image: 'img/godox.png'
    },
    {
        title: 'Neewer luce led 660',
        url: 'https://amzn.to/3jj9063',
        type: 'link',
        image: 'img/neewer660.png'
    },
    {
        title: 'Neewer luce led 176',
        url: 'https://amzn.to/3DpmGDA',
        type: 'link',
        image: 'img/neewer176.png'
    },
    {
        title: 'NEEWER C Stand',
        url: 'https://amzn.to/3JqLj6C',
        type: 'link',
        image: 'img/cstand.png'
    },
    {
        title: 'GODOX Softbox 120cm',
        url: 'https://amzn.to/3WPGJBE',
        type: 'link',
        image: 'img/softbox120.png'
    },
    {
        title: 'NEEWER pannello riflettore',
        url: 'https://amzn.to/3RdrNwh',
        type: 'link',
        image: 'img/riflettore.png'
    },



]

const webLinks: WebLink[] = [
    // {
    //     title: 'Plaud note',
    //     url: 'https://crl.bio/iGQRkMT',
    //     type: 'card',
    //     image: 'img/plaud.jpg'
    // },
    {
        title: 'Tastiere Custom',
        type: 'title',
    },
    {
        title: 'Tastiere',
        type: 'expand',
        data: tastiere,
        image: 'img/nuphyhalo75.png'
    },

    {
        title: 'Switch',
        type: 'expand',
        data: switches,
        image: 'img/durockmamba.png'
    },

    {
        title: 'Cavi',
        type: 'expand',
        data: cavi,
        image: 'img/cavi.png'
    },
    {
        title: 'Tappetini',
        type: 'expand',
        data: tappetini,
        image: 'img/tappetini.png'
    },
    {
        title: 'Accessori',
        type: 'expand',
        data: accessoriTastiere,
        image: 'img/accessori.png'
    },
    {
        title: 'Attrezzatura',
        type: 'title',
    },
    {
        title: 'Camere e obbiettivi',
        type: 'expand',
        data: camere,
        image: 'img/camere.png'
    },
    {
        title: 'Audio',
        type: 'expand',
        data: audio,
        image: 'img/mic.png'
    },
    {
        title: 'Luci',
        type: 'expand',
        data: luci,
        image: 'img/luci.png'
    },
    {
        title: 'Accessori',
        type: 'expand',
        data: accessori,
        image: 'img/accessorifoto.png'
    },
    // {
    //     title: 'PC e periferiche',
    //     type: 'title',
    // },

];

const prova: WebLink[] = [
    {
        title: 'custom keyboard',
        type: 'title',
    },
    {
        title: 'Nuphy Halo75',
        url: 'http://bit.ly/3gcmorf',
        type: 'link',
        coupon: 'NICOLA',
        percent: 10,
        image: 'https://d1fdloi71mui9q.cloudfront.net/kZ6dyaXdRRqOF6RmfUk5_A75_Main01_0901.png'
    },
    {
        title: 'Github',
        data: [
            {
                title: 'custom keyboard',
                type: 'title',
            },
            {
                title: 'Use this template',
                url: 'https://github.com/realvjy/nxt-lnk/generate',
                type: 'link',
                image: './logo192.png'
            },
        ],
        type: 'expand',
        image: './logo192.png'
    },
    {
        url: 'https://github.com/realvjy/nxt-lnk',
        type: 'banner',
        image: 'https://images.unsplash.com/photo-1661961110144-12ac85918e40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80'
    },
    {
        title: 'Deploy on Vercel',
        url: 'https://vercel.com/import/git?s=https://github.com/realvjy/nxt-lnk',
        type: 'link',
        image: './logo192.png'
    },
    {
        title: 'Documentation',
        url: 'https://github.com/realvjy/nxt-lnk#nxt-lnk',
        type: 'link',
        image: './logo192.png'
    },
    {
        title: 'Github',
        url: 'https://github.com/realvjy/nxt-lnk',
        type: 'link',
        image: './logo192.png'
    },
    {
        title: 'altro',
        type: 'title',
    },
    {
        title: 'Nuphy Halo75',
        url: 'https://github.com/realvjy/nxt-lnk',
        type: 'card',
        coupon: 'NICOLA',
        percent: 10,
        image: 'https://images.unsplash.com/photo-1661961110144-12ac85918e40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80'
    }
];

export default webLinks;